export default {"src":"/_next/static/media/bg-image-space-planet.2832526f.svg","height":292,"width":273,"blurWidth":0,"blurHeight":0};